// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewDetailsSkeleton-Label_cls1__YWTEg","cls2":"PaymentChannelViewDetailsSkeleton-Label_cls2__p92aj PaymentChannelViewDetailsSkeleton-Label_cls1__YWTEg"};